export default __webpack_public_path__ + "static/media/mancora-sunset_room_view.43e9571b.jpg";